import { asMutableType, } from '@tymia/shared';
export const appointmentTypeLocation = asMutableType(Object.freeze([
    'onSite',
    'remote',
    'both',
]));
//# sourceMappingURL=AppointmentTypeApi.js.map